// src/app/Picker.tsx: the project picker for someone on several boards (spec 2.3 "root").
import { formatDate } from "../lib/format";
import { me } from "../state/session";
import { EmptyState } from "../ui/EmptyState";
import { Icon } from "../ui/Icon";
import { PlainScreen } from "./NotFound";
import { href, Link } from "./router";

export function Picker() {
  const projects = me.value?.projects ?? [];
  return (
    <PlainScreen>
      <p class="eyebrow">Your boards</p>
      <h1 class="h-page">Pick a Board</h1>
      {projects.length === 0 ? (
        <div style={{ marginTop: "28px" }}>
          <EmptyState title="You don't have a board yet." />
        </div>
      ) : (
        <ul class="hb-picker-list">
          {projects.map((p) => (
            <li key={p.id}>
              <Link to={href("home", { pid: p.id })}>
                <span>
                  <b>{p.title}</b>
                  <span>Last activity {formatDate(p.lastActivityAt, "short")}</span>
                </span>
                <Icon name="chev-r" />
              </Link>
            </li>
          ))}
        </ul>
      )}
    </PlainScreen>
  );
}
